import React, { Component } from 'react';
import Icon from '../components/Icon';

class LoginPage extends Component {
    constructor(props){
        super(props);

        this.state = {
            text:'',
            isValid:true,
            optins:[]
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleOptinSelected = this.handleOptinSelected.bind(this);
    }

    handleOptinSelected(event){
        if(event.target.checked){
            if(this.state.optins.indexOf(event.target.id) === -1){
                var newOptins = this.state.optins;
                newOptins.push(event.target.id);
                this.setState({
                    optins: newOptins
                });
            }
        }else{
            var index = this.state.optins.indexOf(event.target.id);
            if(index !== -1){
                var newOptins = this.state.optins;
                newOptins.splice(index, 1);
                this.setState({
                    optins: newOptins
                });
            }
        }
    }

    handleSubmit(event){
        event.preventDefault();
        var text = this.state.text.trim();
        if(!text || !this.validateEmail(text)){
            this.setState({
                isValid:false
            });
        }else{
            this.props.handleEmailSave(this.state.text, this.state.optins);
            this.setState({
                text:''
            });
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    handleEmailChange(event){
        this.setState({
            text:event.target.value,
            isValid:true
        });
    }

    handleClick(event){
        this.props.handleEmailSave(this.props.userEmail, this.state.optins);
    }

    renderOptins(){
        if(this.props.optinList.length > 0) {
            var items = this.props.optinList.map((optin, index) => {
                var inputId = "isg_optin_" + index;
                return (
                    <div className="isg_optin">
                        <input
                            type="checkbox"
                            name={inputId}
                            value={inputId}
                            id={inputId}
                            onChange={this.handleOptinSelected}
                        />
                        <label htmlFor={inputId} className="isg_optin_label">
                            <span className="isg_optin_icon isg_optin_icon_selected"><Icon value="icon_checkbox_on" /></span>
                            <span className="isg_optin_icon isg_optin_icon_default"><Icon value="icon_checkbox" /></span>
                            {optin.value}
                        </label>
                    </div>
                );
            });
            return items;
        }else{
            return ('');
        }
    }

    renderNoFormNeeded(){
        return (
          <div className="isg_no_form">
                <p>Pour obtenir votre résultat, renseignez les informations</p>
              {this.renderOptins()}
              <button className="isg_btn" onClick={this.handleClick} >Découvrir mon résultat</button>
          </div>
        );
    }

    renderErrorMessage(){
        return(
          <div className="isg_form_error">Vous devez indiquer une adresse email valide</div>
        );
    }

    renderForm(){
        return(
            <div className="isg_form">
                <p>Pour obtenir votre résultat, renseignez les informations</p>
                {this.state.isValid === false ? this.renderErrorMessage() : ''}
                <form onSubmit={this.handleSubmit}>
                    <input
                        type="text"
                        name="isg_user_email"
                        placeholder="Entrez votre email"
                        value={this.state.text}
                        onChange={this.handleEmailChange}
                        onFocus={this.props.handleFocusEmail}
                        onBlur={this.props.handleBlurEmail}
                    />
                    {this.renderOptins()}
                    <button className="isg_btn" type="submit">Découvrir mon résultat</button>
                </form>
            </div>
        );
    }

    _getLogoWithBanner(){
        return (
            <div className="isg_logo">
            <img src={this.props.imgBanner} alt="" />
            </div>
    );
    }

    _getLogoWithoutBanner(){
        return (
            <div className="isg_logo"></div>
    );
    }

    render(){
        var banner = '';
        if(this.props.imgBanner !== ''){
            banner = this._getLogoWithBanner();
        }else{
            banner = this._getLogoWithoutBanner();
        }
        return (
            <div className="isg_panel isg_login_page  isg_bg_base">
                <div className="isg_panel_content">
                    {banner}
                    <div className="isg_login_page_content">
                        <h1>C'est presque fini !</h1>
                        {(typeof this.props.userEmail !== 'undefined' && this.props.userEmail !== false && this.props.userEmail.trim() !== '') ? this.renderNoFormNeeded() : this.renderForm()}
                    </div>
                </div>
            </div>
        );
    }

}

LoginPage.propTypes = {
    userEmail: React.PropTypes.string,
    handleEmailSave: React.PropTypes.func.isRequired,
    handleFocusEmail: React.PropTypes.func,
    handleBlurEmail: React.PropTypes.func,
    optinList: React.PropTypes.array.isRequired,
    imgBanner: React.PropTypes.string
};

export default LoginPage;


/** WEBPACK FOOTER **
 ** ./src/components/LoginPage.js
 **/